parseScalarTypeExtension